/// <amd-module name="TFS/Admin/OrganizationAadControls/Components/AadResolvePanel/AadResolvePanel" />
import React = require("react");

import AdminResources = require("TFS/Admin/OrganizationAadControls/Resources");
import { IButtonProps } from "VSSUI/Button";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";
import { Table, ITableColumn, TableCell } from "VSSUI/Table";
import { Status, StatusSize, Statuses } from "VSSUI/Status";
import { VssPersona } from "VSSUI/VssPersona";
import { ContentSize } from "VSSUI/Callout";
import { Panel } from "VSSUI/Panel";
import { format } from "VSS/Core/Util/String";
import { getIdentityImageUrl } from "VSS/Platform/Identity";
import { IUserMappingData, IIdentityMembershipData } from "TFS/Admin/OrganizationAadCommon/Contracts/DataModels";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { IPeoplePickerProvider, IIdentity } from "VSSUI/IdentityPicker";
import { PeoplePickerProvider } from "VSS/Features/Identities/IdentityPickerProvider";
import { PeoplePickerWrapperComponent } from "Components/AadResolvePanel/PeoplePickerWrapper";
import { createMarkup } from "TFS/Admin/Common/Util/HtmlString";
import { filterXSS } from "xss";
import { VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";
import { IAadResolvePanelComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/ComponentControls.props";
import { IVssContributionService } from "VSS/Platform/Contribution";

const identityMembershipDataProviderId = "ms.vss-admin-web.organization-aad-identity-membership-data-provider";

interface IAadResolvePanelComponentState {
    userMappingData: IUserMappingData[];
    shouldNextBeDisabled: boolean;
    listOfMembershipWarningEmails: string[];
}

export class AadResolvePanelComponent extends React.Component<IAadResolvePanelComponentProps, IAadResolvePanelComponentState> {
    private _pickerProvider: IPeoplePickerProvider;

    public constructor(props: IAadResolvePanelComponentProps) {
        super(props);

        var mappingData: IUserMappingData[] = [];
        props.disconnectUsers.forEach(function(element) {
            mappingData.push({
                status: false,
                currentUserDescriptor: element.descriptor,
                currentUserEmail: element.preferredEmailAddress,
                mappingOriginId: "",
                mappingIdentityEmail: "",
                shouldShowActiveOrInactiveMembershipWarning: false,
                shouldShowCannotVerifyWarning: false
            });
        });

        this._pickerProvider = new PeoplePickerProvider(this.props.pageContext, {
            options: {
                MinResults: 5,
                MaxResults: 20
            },
            identityTypes: ["user"],
            operationScopes: ["source"]
        });
        this._pickerProvider.onEmptyInputFocus = (): IIdentity[] => {
            return [];
        };

        this.state = {
            userMappingData: mappingData,
            shouldNextBeDisabled: false,
            listOfMembershipWarningEmails: []
        };
    }

    public render(): JSX.Element {
        const footerButtons: IButtonProps[] = [
            {
                onClick: this.props.onDismiss,
                text: AdminResources.Cancel
            },
            {
                className: "primary-action-button",
                onClick: () => {
                    this.props.onMapIdentities(this.state.userMappingData);
                },
                primary: true,
                text: AdminResources.Next,
                disabled: this.state.shouldNextBeDisabled
            }
        ];

        const columns = [
            { id: "status", name: "", width: 25, renderCell: this._renderStatusCell },
            { id: "currentEmail", name: AdminResources.AadResolveColumnCurrentEmail, width: -100, renderCell: this._renderCurrentEmailCell },
            { id: "mappingEmail", name: AdminResources.AadResolveColumnMatchedIdentity, width: 290, renderCell: this._renderPeoplePickerCell }
        ];

        return (
            <Panel
                onDismiss={this.props.onDismiss}
                titleProps={{ text: AdminResources.ResolvePanelTitle }}
                description={
                    this.props.isAadGuestUser === true
                        ? format(AdminResources.ResolvePanelDescriptionForGuestUser, this.props.orgTenantData.displayName)
                        : format(AdminResources.ResolvePanelDescription, this.props.orgTenantData.displayName)
                }
                size={ContentSize.Large}
                footerButtonProps={footerButtons}
            >
                {this._renderPanelBody(columns)}
            </Panel>
        );
    }

    private _renderPanelBody(columns: any): JSX.Element {
        return (
            <div className="width-100 aad-connect-panel-body">
                {this.props.isAadGuestUser === true ? (
                    <div className="bottom-margin">
                        <MessageBar severity={MessageBarSeverity.Warning}>
                            <span
                                className="text-word-break"
                                dangerouslySetInnerHTML={createMarkup(
                                    format(
                                        AdminResources.AadResolveGuestMemberWaring,
                                        filterXSS(this.props.orgTenantData.displayName)
                                    )
                                )}
                            />
                        </MessageBar>
                    </div>
                ) : null}
                {this.state.listOfMembershipWarningEmails && this.state.listOfMembershipWarningEmails.length > 0 ? (
                    <div className="bottom-margin">
                        <MessageBar severity={MessageBarSeverity.Warning}>
                            <span
                                className="text-word-break"
                                dangerouslySetInnerHTML={createMarkup(
                                    format(
                                        AdminResources.ActiveOrInactiveMembershipWarning,
                                        filterXSS(this.state.listOfMembershipWarningEmails.join(", "))
                                    )
                                )}
                            />
                        </MessageBar>
                    </div>
                ) : null}
                <div className="user-mapping-div">
                    <Table
                        itemProvider={new ArrayItemProvider(this.props.disconnectUsers)}
                        columns={columns}
                        className={"resolve-panel-table"}
                        scrollable={true}
                    />
                </div>
                {this.props.isAadGuestUser === true ? null : (
                    <div className="big-top-margin">
                        <MessageBar severity={MessageBarSeverity.Info}>
                            <span className="text-word-break">{AdminResources.AadResolveMappingInfo}</span>
                        </MessageBar>
                    </div>
                )}
            </div>
        );
    }

    private _renderStatusCell = (index: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: any): JSX.Element => {
        return (
            <TableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex + "-row-" + index}>
                {this.state.userMappingData[index].shouldShowActiveOrInactiveMembershipWarning === true ||
                this.state.userMappingData[index].shouldShowCannotVerifyWarning === true ? (
                    <Icon
                        iconName="Warning"
                        className="aad-mapping-warning-icon"
                        tooltipProps={{
                            text: this.state.userMappingData[index].shouldShowActiveOrInactiveMembershipWarning
                                ? AdminResources.ActiveOrInactiveMembershipWarningTooltip
                                : AdminResources.CannotVerifyStateWarningTooltip
                        }}
                    />
                ) : this.state.userMappingData[index].status === true ? (
                    <Status {...Statuses.Success} key="success" size={StatusSize.m} className="status-example" />
                ) : (
                    <Icon
                        iconName="ErrorBadge"
                        className="aad-mapping-error-icon"
                        tooltipProps={{ text: AdminResources.AadMappingTableErrorIconTooltip }}
                    />
                )}
            </TableCell>
        );
    };

    private _renderCurrentEmailCell = (index: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: any): JSX.Element => {
        return (
            <TableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex + "-row-" + index}>
                <div className="user-info-details flex-row flex-center">
                    <VssPersona
                        identityDetailsProvider={{
                            getIdentityImageUrl: (size: number): string | undefined => {
                                return this._getUserImage(tableItem.id);
                            },
                            getDisplayName: (): string => {
                                return "";
                            }
                        }}
                        size={"medium"}
                    />
                    <div className="small-left-margin">
                        <div className="fontWeightSemiBold">{tableItem.displayName}</div>
                        <div className="grey-font">{tableItem.preferredEmailAddress}</div>
                    </div>
                </div>
            </TableCell>
        );
    };

    private _renderPeoplePickerCell = (index: number, columnIndex: number, tableColumn: ITableColumn<any>, tableItem: any): JSX.Element => {
        return (
            <TableCell columnIndex={columnIndex} tableColumn={tableColumn} key={"col-" + columnIndex + "-row-" + index}>
                <div className={this.props.isAadGuestUser === true ? "resolve-panel-people-picker-disabled" : ""}>
                    <PeoplePickerWrapperComponent
                        index={index}
                        pickerProvider={this._pickerProvider}
                        isAadGuestUser={this.props.isAadGuestUser}
                        onUpdateMappingIdentity={this._onUpdateMappingIdentity}
                        onClearSearchBox={this._onClearSearchBox}
                    />
                </div>
            </TableCell>
        );
    };

    protected _onClearSearchBox = (index: number) => {
        var updatedIdentity = this.state.userMappingData;
        var showMembershipWarningList = this.state.listOfMembershipWarningEmails;
        showMembershipWarningList = showMembershipWarningList.filter(elem => elem !== updatedIdentity[index].mappingIdentityEmail);
        updatedIdentity[index].status = false;
        updatedIdentity[index].mappingOriginId = "";
        updatedIdentity[index].mappingIdentityEmail = "";
        updatedIdentity[index].shouldShowCannotVerifyWarning = false;
        updatedIdentity[index].shouldShowActiveOrInactiveMembershipWarning = false;
        this.setState({
            userMappingData: updatedIdentity,
            listOfMembershipWarningEmails: showMembershipWarningList
        });
    };

    protected _onUpdateMappingIdentity = async (index: number, mappingIdentity?: IIdentity) => {
        var updatedIdentity = this.state.userMappingData;
        if (mappingIdentity) {
            if (mappingIdentity.originId) {
                await this._onCheckActiveOrInactiveMembership(updatedIdentity, index, mappingIdentity);
            } else {
                updatedIdentity[index].status = false;
                updatedIdentity[index].shouldShowActiveOrInactiveMembershipWarning = false;
            }
        } else {
            updatedIdentity[index].status = false;
            updatedIdentity[index].shouldShowCannotVerifyWarning = false;
            updatedIdentity[index].shouldShowActiveOrInactiveMembershipWarning = false;
        }
        this.setState({
            userMappingData: updatedIdentity
        });
    };

    protected _onCheckActiveOrInactiveMembership = async (updatedIdentity: IUserMappingData[], index: number, mappingIdentity: IIdentity) => {
        this.setState({
            shouldNextBeDisabled: true
        });

        const service = this.props.pageContext.getService<IVssContributionService>("IVssContributionService");
        let result = await service.getDataAsync<IIdentityMembershipData>(
            identityMembershipDataProviderId,
            {
                originId: mappingIdentity.originId
            },
            true //ignore cache = true
        )!;

        if (result) {
            if (result.hasActiveOrInactiveMembership === true) {
                updatedIdentity[index].shouldShowActiveOrInactiveMembershipWarning = true;

                if (mappingIdentity.signInAddress) {
                    var showMembershipWarningList = this.state.listOfMembershipWarningEmails;
                    showMembershipWarningList.push(mappingIdentity.signInAddress);
                    this.setState({
                        listOfMembershipWarningEmails: showMembershipWarningList
                    });
                }
            } else {
                updatedIdentity[index].shouldShowActiveOrInactiveMembershipWarning = false;
                var showMembershipWarningList = this.state.listOfMembershipWarningEmails;
                showMembershipWarningList = showMembershipWarningList.filter(elem => elem !== updatedIdentity[index].mappingIdentityEmail);
                this.setState({
                    listOfMembershipWarningEmails: showMembershipWarningList
                });
            }

            updatedIdentity[index].shouldShowCannotVerifyWarning = false;
            updatedIdentity[index].mappingOriginId = mappingIdentity.originId;
            updatedIdentity[index].status = true;
            updatedIdentity[index].mappingIdentityEmail = mappingIdentity.signInAddress ? mappingIdentity.signInAddress : "";
        } else {
            updatedIdentity[index].shouldShowCannotVerifyWarning = true;
        }

        this.setState({
            shouldNextBeDisabled: false
        });
    };

    private _getUserImage(userId: string) {
        var url = getIdentityImageUrl(this.props.pageContext, userId);
        return url;
    }
}

VssComponent.register("ms.vss-admin-web.aad-resolve-panel", AadResolvePanelComponent);
